import type { DefaultNodeTypes, SerializedListItemNode, SerializedListNode } from '@payloadcms/richtext-lexical';
import type { NodeTypes } from './serialize';

export const hasChildren = (node: NodeTypes): node is NodeTypes & { children: NodeTypes[] } => {
	return Array.isArray((node as { children?: unknown }).children);
};

export function isObject(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null;
}

export function hasArrayChildren(value: unknown): value is { children: unknown[] } {
	return isObject(value) && Array.isArray((value as { children?: unknown[] }).children);
}

export function isListNode(node: unknown): node is SerializedListNode<DefaultNodeTypes> {
	return isObject(node) && (node as { type?: unknown }).type === 'list';
}

export function isOrderedListNode(node: unknown): node is SerializedListNode<DefaultNodeTypes> & { tag: 'ol' } {
	return isListNode(node) && (node as SerializedListNode).tag === 'ol';
}

export function isListItemNode(node: unknown): node is SerializedListItemNode<DefaultNodeTypes> {
	return isObject(node) && (node as { type?: unknown }).type === 'listitem';
}
